import { useCallback, useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";

const ADMIN_ID = 1;
const TENANT_STORE_ID = 1;

export const useAccountType = () => {
  const { auth } = useSelector(
    (state) => ({
      auth: state.auth,
    }),
    shallowEqual
  );

  const PERMISSION_LIST = useMemo(() => {
    if (!auth || !auth.user) return [];

    if (!auth.user.permissions) return [];

    return auth.user.permissions.map((item) => item.name);
  }, [auth]);

  const hasPermission = useCallback(
    (permissionToCheck) => {
      if (
        typeof permissionToCheck !== "string" &&
        Array.isArray(permissionToCheck)
      ) {
        let hasPermission = false;
        permissionToCheck.forEach((v) => {
          if (PERMISSION_LIST.includes(v)) {
            hasPermission = true;
            return;
          }
        });
        return hasPermission;
      }

      return PERMISSION_LIST.includes(permissionToCheck) ? true : false;
    },
    [PERMISSION_LIST]
  );

  const isStoreUser = useCallback(() => {
    if (!auth || !auth.user) return false;
    return auth.user.tenant && auth.user.tenant.tenantTypeId === TENANT_STORE_ID
      ? true
      : false;
  }, [auth]);

  const isAdminUser = useCallback(() => {
    if (
      !auth ||
      !auth.user ||
      !auth.user.accountType ||
      !auth.user.accountType.id
    )
      return false;
    return auth.user.accountType.id === ADMIN_ID ? true : false;
  }, [auth]);

  return {
    permissions: PERMISSION_LIST,
    hasPermission,
    isStoreUser,
    isAdminUser,
  };
};